// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__1HRUY","left":"InfoRow_left__380VN"};